<ng-content></ng-content>
<div class="card card-block panel panel-default panel-body">
  <br>
  <div class="row" style="margin: 0px;">
  </div>
</div>
